// libraries
import React from "react";
import PropTypes from "prop-types";

// components
import CreatorInfo from "./CreatorInfo";

import { AttributionBacklinkProvider } from "icons/AttributionBacklink/Context";

//styles
import colors from "core/colors";
import {
    ImageDetailHeroSectionContainer,
    ImageDetailGridContainer,
    LeftColGridItem,
    RightColGridItem,
    RightColumnInnerContainer
} from "./styles";

const ImageDetailHero = ({
    leftColumnContent,
    rightColumnContent,
    image,
    imageType
}) => {
    if (!image) return null;

    const { title, creator, tags, id, slugWithId } = image;

    return (
        <AttributionBacklinkProvider
            iconTitle={title}
            creatorName={creator.name}
            iconId={id}
            slugWithId={slugWithId}
        >
            <ImageDetailHeroSectionContainer bgColor={colors.secondary.orca}>
                <ImageDetailGridContainer
                    mobileSpacing={0}
                    tabletSpacing={16}
                    desktopSpacing={16}
                >
                    <LeftColGridItem item sm={12} md={8} lg={8}>
                        {leftColumnContent}
                    </LeftColGridItem>
                    <RightColGridItem item sm={12} md={4} lg={4}>
                        <RightColumnInnerContainer>
                            <CreatorInfo
                                imageType={imageType}
                                title={title}
                                creator={creator}
                            />
                            {rightColumnContent}
                        </RightColumnInnerContainer>
                    </RightColGridItem>
                </ImageDetailGridContainer>
            </ImageDetailHeroSectionContainer>
        </AttributionBacklinkProvider>
    );
};

ImageDetailHero.propTypes = {
    leftColumnContent: PropTypes.element,
    rightColumnContent: PropTypes.element,
    image: PropTypes.object,
    imageType: PropTypes.oneOf(["photo", "icon"]).isRequired
};

export default ImageDetailHero;
